import { OffreModel, OffresResultatRechercheModel, OffresSimilairesModel } from '../../../modules/offre/types/OffreModel'
import { getLotCompleteCategoryKey } from '../../../enums/lot/lotCompleteTypesEnum'
import { IntlShape } from 'react-intl'

export const formatOffreResultatRecherche = (
	offreResultat: OffresResultatRechercheModel,
	intl: IntlShape,
	photosWidth: number | string,
	photosHeight: number | string
) => ({
	surTitre: intl.formatMessage(
		{
			id: `offre.offresLiees.surTitre.${offreResultat.type}`,
			defaultMessage: 'Appartement {genre}',
			description: 'Surtitre de l\'offre'
		},
		{
			genre: offreResultat.genre ? intl.formatMessage({
				id: `lot.details.completeCategory.${getLotCompleteCategoryKey(Number(offreResultat.genre))}`,
				defaultMessage: '2 pièces',
				description: 'Complete category label'
			}) : ''
		}
	),
	lieuOffre: offreResultat.sousTitre,
	alias: offreResultat.alias,
	photosMobiles: offreResultat.photos,
	photosWidth: photosWidth,
	photosHeight: photosHeight,
	atouts: offreResultat.atouts,
	tags: offreResultat.tags,
	surface: offreResultat.surface,
	tarification: offreResultat.tarification?.prixMensuel,
	identifiantCRMOffre: offreResultat.identifiantCRMOffre
})

export const formatOffreModel = (
	offre: OffreModel,
	intl: IntlShape,
	photosWidth: number | string,
	photosHeight: number | string
) => {
	return ({
		surTitre: intl.formatMessage(
			{
				id: `offre.offresLiees.surTitre.${offre.type}`,
				defaultMessage: 'Appartement {genre}',
				description: 'Surtitre de l\'offre'
			},
			{
				genre: offre.genre ? intl.formatMessage({
					id: `lot.details.completeCategory.${getLotCompleteCategoryKey(Number(offre.genre))}`,
					defaultMessage: '2 pièces',
					description: 'Complete category label'
				}) : ''
			}
		),
		lieuOffre: offre.residence.sousTitre,
		alias: offre.meta?.alias_fr || '',
		photosMobiles: offre.photos,
		photosWidth: photosWidth,
		photosHeight: photosHeight,
		atouts: offre.atouts,
		tags: offre.tags,
		surface: offre.surface,
		tarification: offre.tarification.prixMensuel,
		identifiantCRMOffre: offre.identifiantCRMOffre
	})
}

export const formatOffreSimilaireModel = (
	offreSimilaire: OffresSimilairesModel,
	intl: IntlShape,
	photosWidth: number | string,
	photosHeight: number | string
) => {
	return ({
		surTitre: intl.formatMessage(
			{
				id: `offre.offresLiees.surTitre.${offreSimilaire.type}`,
				defaultMessage: 'Appartement {genre}',
				description: 'Surtitre de l\'offre'
			},
			{
				genre: offreSimilaire.genre ? intl.formatMessage({
					id: `lot.details.completeCategory.${getLotCompleteCategoryKey(Number(offreSimilaire.genre))}`,
					defaultMessage: '2 pièces',
					description: 'Complete category label'
				}) : ''
			}
		),
		lieuOffre: offreSimilaire.sousTitre,
		alias: offreSimilaire.alias,
		photosMobiles: offreSimilaire.photos,
		photosWidth: photosWidth,
		photosHeight: photosHeight,
		atouts: offreSimilaire.atouts,
		surface: offreSimilaire.surface,
		tags: offreSimilaire.tags,
		tarification: offreSimilaire.tarification.prixMensuel,
		identifiantCRMOffre: offreSimilaire.identifiantCRMOffre
	})
}